module.exports = __webpack_public_path__ + "img/antes_despues_56.b35fa879.png";